import { CSSProperties } from 'react';
import { Column } from './types';

export function calculateLeftOffset<Data extends Record<string, any>, Context>(
  columns: Column<Data, Context>[],
  index: number
) {
  return columns
    .slice(0, index)
    .filter(col => col.fixed === 'left')
    .reduce((offset, col) => offset + (parseInt(col.width || '0', 10) || 0), 0);
}

export function calculateRightOffset<Data extends Record<string, any>, Context>(
  columns: Column<Data, Context>[],
  index: number
) {
  return columns
    .slice(index + 1)
    .filter(col => col.fixed === 'right')
    .reduce((offset, col) => offset + (parseInt(col.width || '0', 10) || 0), 0);
}

export function getStickySx<Data extends Record<string, any>, Context>(
  column: Column<Data, Context>,
  columns: Column<Data, Context>[],
  columnIndex: number
): CSSProperties {
  return {
    ...(column.fixed === 'left' && {
      zIndex: 10,
      position: 'sticky',
      left: calculateLeftOffset(columns, columnIndex),
    }),
    ...(column.fixed === 'right' && {
      zIndex: 10,
      position: 'sticky',
      right: calculateRightOffset(columns, columnIndex),
    }),
  };
}
